import { render, staticRenderFns } from "./NHPriceId.vue?vue&type=template&id=0fab38a7&"
import script from "./NHPriceId.vue?vue&type=script&lang=js&"
export * from "./NHPriceId.vue?vue&type=script&lang=js&"
import style0 from "./NHPriceId.vue?vue&type=style&index=0&id=0fab38a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports